import styled, { css } from 'styled-components';

export const card = css`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey2};
`;

export const Card = styled.div`
  ${card};
`;
